import React from "react";
import "./style.scss";
import Player from "../index";
import { usePlayerContext } from "../../../context/PlayerContext";
import { useUserContext } from "../../../context/UserContext";

export default ({ isHallsPage }) => {
    const { stream } = usePlayerContext();
    const { requireAuth } = useUserContext();

    if (!stream || requireAuth) {
        return <div className={'player-container'} id="player-container"/>;
    }

    return (
        <div className={'player-container'} id="player-container">
            <Player isHallsPage={isHallsPage} />
        </div>
    );
}
